import { Box } from "@mui/material";
import { useHasFeature } from "shared-ui/Feature";
import { useParams } from "react-router-dom-v5-compat";
import { MenuBuilderGrid } from "../../../../views/MenuBuilder/Builder/MenuBuilderGrid";
import { MenuBuilderProvider } from "../../../../views/MenuBuilder/Builder/MenuBuilderProvider";

export const MenuBuilderPage = () => {
  const { plannedMenuId } = useParams();
  const showMenuBuilder = useHasFeature("performanceKitchen");

  if (showMenuBuilder) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          alignSelf: "stretch",
          minHeight: 0,
          minWidth: 0,
          height: "100%",
          overflow: "hidden",
        }}
      >
        <MenuBuilderProvider plannedMenuId={plannedMenuId || ""}>
          <MenuBuilderGrid />
        </MenuBuilderProvider>
      </Box>
    );
  }
  return null;
};
